import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "w-full sm:flex" }
const _hoisted_2 = { class: "sm:w-1/3 sm:pr-10" }
const _hoisted_3 = { class: "sm:w-2/3 sm:pl-10" }
const _hoisted_4 = { value: "" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "flex items-center mt-20" }
const _hoisted_7 = {
  type: "submit",
  class: "c-button min-w-100"
}
const _hoisted_8 = {
  key: 1,
  class: "max-w-700"
}
const _hoisted_9 = {
  key: "street",
  class: "block mb-5"
}
const _hoisted_10 = {
  key: "description",
  class: "block mb-5"
}
const _hoisted_11 = {
  key: "zipcity",
  class: "block mb-5"
}
const _hoisted_12 = {
  key: "country",
  class: "block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputPhone = _resolveComponent("InputPhone")!
  const _component_WebApiMessage = _resolveComponent("WebApiMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_ProfileInfoItem = _resolveComponent("ProfileInfoItem")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_Transition, {
      name: "o-anim-fade-300",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.editMode)
          ? (_openBlock(), _createBlock(_component_Form, {
              key: 0,
              "initial-values": _ctx.getDefaultEditValues(),
              "validation-schema": _ctx.formValidation,
              class: "mt-30 max-w-500",
              onSubmit: _ctx.submit
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  name: "street",
                  label: _ctx.labels.addressStreetLabel,
                  autofocus: true
                }, null, 8, ["label"]),
                _createVNode(_component_InputText, {
                  name: "street2",
                  label: _ctx.labels.addressAppartmentLabel
                }, null, 8, ["label"]),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_InputText, {
                      name: "zip",
                      label: _ctx.labels.addressPostalCodeLabel
                    }, null, 8, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_InputText, {
                      name: "city",
                      label: _ctx.labels.addressCityLabel
                    }, null, 8, ["label"])
                  ])
                ]),
                _createVNode(_component_InputSelect, {
                  label: _ctx.labels.addressCountryLabel,
                  class: "w-full",
                  name: "countryCode"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.labels.addressSelectCountryLabel), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: country.code,
                        value: country.code
                      }, _toDisplayString(country.name), 9, _hoisted_5))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_InputPhone, {
                  name: "phone",
                  label: _ctx.labels.phoneLabel
                }, null, 8, ["label"]),
                _createVNode(_component_InputPhone, {
                  name: "alternativePhone",
                  label: _ctx.labels.alternativePhoneLabel
                }, null, 8, ["label"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-dusty-grey c-magic-line mr-40",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearEditMode && _ctx.clearEditMode(...args)), ["prevent"]))
                  }, _toDisplayString(_ctx.labels.editMyAddressCancelButton), 1),
                  _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.labels.editMyAddressSaveButton), 1)
                ]),
                _createVNode(_component_WebApiMessage, {
                  id: _ctx.editProfileAddressWebApiMessageKey,
                  "clear-timing": 3000,
                  class: "mt-30"
                }, null, 8, ["id"])
              ]),
              _: 1
            }, 8, ["initial-values", "validation-schema", "onSubmit"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "text-dusty-grey c-magic-line mb-15",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.setEditMode && _ctx.setEditMode(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.labels.editMyAddressButton), 1),
              _createVNode(_component_ProfileInfoItem, {
                title: _ctx.labels.fullAddressLabel,
                class: "mb-30"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (_ctx.address.street)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.address.street), 1))
                      : _createCommentVNode("", true),
                    (_ctx.address.street2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.address.street2), 1))
                      : _createCommentVNode("", true),
                    (_ctx.address.zip || _ctx.address.city)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.address.zip) + " " + _toDisplayString(_ctx.address.city), 1))
                      : _createCommentVNode("", true),
                    (_ctx.address.country)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.address.country), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(_component_ProfileInfoItem, {
                title: _ctx.labels.phoneLabel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.address.phone), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              (_ctx.address.alternativePhone)
                ? (_openBlock(), _createBlock(_component_ProfileInfoItem, {
                    key: "alternativePhone",
                    title: _ctx.labels.alternativePhoneLabel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.address.alternativePhone), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true)
            ]))
      ]),
      _: 1
    })
  ]))
}